import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  TextField,
  Modal,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import HeresAmericaService from "../services/HA/HeresAmericaService.js";
import { displaySuccessToast, displayErrorToast } from "../utils/toast.js";
import AddSeries from "./ha_components/AddSeries";
// Define styles
const useStyles = makeStyles((theme) => ({
  actionsCell: {
    display: "flex",
    justifyContent: "flex-end",
  },
  normalRow: {},
  editingRow: {
    minWidth: "100%",
    overflow: "hidden",
    // transition: 'max-height 0.3s ease-in-out',
    minHeight: "40vh",
  },
  collapsed: {
    maxHeight: 0,
  },
}));

export default function HaBookManager() {
  const [open, setOpen] = useState(false);
  const [tagTodelete, setTagTodelete] = useState("");
  const [newTagName, setNewTagName] = useState(""); // State for the new tag name
  const [tagBeingEdited, setTagBeingEdited] = useState(null);
  const [tempTagName, setTempTagName] = useState("");
  const [isWorking, setIsWorking] = useState(false);

  // State for Tags
  const [openTagDialog, setOpenTagDialog] = useState(false);
  const [tagIdToDelete, setTagIdToDelete] = useState(null);
  const [tagToDelete, setTagToDelete] = useState("");

  // State for Series

  const [openSeriesDialog, setOpenSeriesDialog] = useState(false);
  const [seriesIdToDelete, setSeriesIdToDelete] = useState(null);
  const [seriesToDelete, setSeriesToDelete] = useState("");
  const [bookSeries, setBookSeries] = useState([]);
  const [newSeriesName, setNewSeriesName] = useState("");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  });

  const [bookTags, setBookTags] = useState([]);
  useEffect(() => {
    getBookTags();
    getBookSeries();
  }, [pagination.currentPage]);
  const startEditTag = (id, currentName) => {
    setTagBeingEdited(id);
    setTempTagName(currentName);
  };
  async function getBookTags() {
    const res = await HeresAmericaService.getAllTags();
    console.log("🚀 ~ getBookTags ~ res:", res);
    console.log(res);
    setBookTags(res);
  }
  const handleAddTag = async () => {
    try {
      const response = await HeresAmericaService.createTag(newTagName);
      console.log(response);
      displaySuccessToast("🙌 New tag added! 🙌");
      setBookTags([...bookTags, response]);
    } catch (error) {
      console.log(error.response.data.error);
      if (error.response.data.error) {
        displayErrorToast(`ERROR adding tag! ${error.response.data.error}`);
      } else {
        displayErrorToast(" ERROR adding tag! ");
      }
      console.error("Error adding new tag:");
    }
  };

  const handleEditTag = async (id) => {
    try {
      const response = await HeresAmericaService.updateTag(id, tempTagName);
      const data = bookTags.map((tag) => (tag.id === id ? response : tag));
      setBookTags(data);
      displaySuccessToast("Tag updated!");
      setTagBeingEdited(null); // Reset the editing state
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        displayErrorToast(`ERROR updating tag! ${error.response.data.error}`);
      } else if (error.message) {
        displayErrorToast(`ERROR updating tag! ${error.message}`);
      } else {
        displayErrorToast("ERROR updating tag!");
      }
      console.error("Error updating tag:", error);
    }
  };

  const handleDeleteTag = async (id, name) => {
    setIsWorking(true);
    try {
      // Call the delete API
      const res = await HeresAmericaService.deleteTag(id, name);
      console.log(res);
      const filterTags = bookTags.filter((tag) => tag.id !== id);
      // Remove the deleted tag from local state
      setBookTags(filterTags);

      // Display success toast
      displaySuccessToast("Tag deleted!");
      setIsWorking(false);
    } catch (error) {
      console.error("Error deleting tag:", error);
      setIsWorking(false);
      // Check for specific error message and display error toast
      if (error.response && error.response.data.error) {
        displayErrorToast(` Error deleting tag! ${error.response.data.error} `);
      } else {
        displayErrorToast(" Error deleting tag! ");
      }
    }
  };

  const handleOpenDialog = (id, name) => {
    setTagIdToDelete(id);
    setOpen(true);
    setTagTodelete(name);
  };

  const handleCloseDialog = () => {
    setTagIdToDelete(null);
    setOpen(false);
  };

  const confirmDeleteTag = async () => {
    await handleDeleteTag(tagIdToDelete);
    setTagIdToDelete(null);
    setOpen(false);
  };

  async function getBookSeries() {
    try {
      const res = await HeresAmericaService.getAllSeries(
        pagination.currentPage
      );
      console.log(
        "🚀 ~ file: HeresAmericaManager.jsx:180 ~ getBookSeries ~ res:",
        res
      );
      setBookSeries(res.series);
      setPagination(res.pagination);
    } catch (error) {
      console.error("Error fetching series:", error);
      displayErrorToast("Error fetching series!");
    }
  }

  const handleOpenSeriesDialog = (id, name, slug) => {
    setSeriesIdToDelete(slug);
    setOpenSeriesDialog(true);
    setSeriesToDelete(name);
  };

  const handleCloseSeriesDialog = () => {
    setOpenSeriesDialog(false);
  };

  const confirmDeleteSeries = async () => {
    setIsWorking(true);
    try {
      const res = await HeresAmericaService.deleteSeries(seriesIdToDelete); // Assuming handleDeleteSeries is implemented

      displaySuccessToast("Series Succesfully Deleted!");
      setOpenSeriesDialog(false);
      setSeriesIdToDelete(null);
      setIsWorking(false);
      getBookSeries();
      console.log(res);
    } catch (e) {
      console.log(e);
      setIsWorking(false);

      displayErrorToast("Series Error Deleting! " + e.response.data.error);
    }
  };

  const [seriesBeingEdited, setSeriesBeingEdited] = useState(null);
  const [tempSeries, setTempSeries] = useState({});

  useEffect(() => {
    // Assume that you have a function getBookSeries()
    // that fetches all series and sets the bookSeries state.
    getBookSeries();
    getBookTags();
  }, []);

  const refreshSeries = () => {
    getBookSeries();
  };
  const startEditSeries = (series) => {
    setSeriesBeingEdited(series.id);
    setTempSeries(series);
  };

  const handleEditSeries = async (id) => {
    // (API call to update the series)
    try {
      console.log(tempSeries);
      const updatedSeries = await HeresAmericaService.updateSeries(tempSeries);
      setBookSeries(
        bookSeries.map((series) => (series.id === id ? updatedSeries : series))
      );
      displaySuccessToast("Series updated!");
      setSeriesBeingEdited(null);
    } catch (error) {
      displayErrorToast("Series errror!");
      console.log(error);
      // Error handling here
    }
  };
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [addSeriesOpen, setAddSeriesOpen] = useState(false);
  const handleOpen = () => setAddSeriesOpen(true);
  const handleClose = () => setAddSeriesOpen(false);
  const classes = useStyles();

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <div>
          <svg
            className="absolute-center"
            width="100vw"
            height="20vh"
            viewBox="0 0 223.505 134.43"
            fill="#fff"
            stroke="#003166"
            strokeWidth={0.75}
            strokeMiterlimit={12}
          >
            <path d="M187.475 27.28c1.3-.7 1.5-1.1 2.6-1.5 2.1-.7 4.2 0 5.7.8-1.3-1.7-3.9-4.6-8.1-5.7-2.1-.5-4.8-.7-12.4 2-3.9 1.4-9.3 3.7-15.4 7.3 1.8-.7 3.8-1.4 5.9-2 3-.9 5.7-1.5 8.3-1.8 1 .8 3.3 2.2 6.5 2.4 3.6.3 6.3-1.1 6.9-1.5zm-5.5-2.7c.3-.3.6-.7 1.1-.8 1.3-.3 2.7-.5 3.9-.3.1 0 .3 0 .3.1.2.1.2.3.3.5 0 .9-.6 1.5-1.3 2-1 .8-2.9 1.5-4 .4-.5-.6-.6-1.3-.3-1.9zm14.4 13.2c-1 .4-2.6 1.2-5.2 2.2-4.1 1.5-7.6 2.1-10 2.5 1.3.9 3.4 2.1 6.3 2.7.9.2 2 .3 2.9.4-.9.6-1.5 1.5-2 2.3-.9 1.5-1.8 2.8-2.6 4.4-.9 1.8-1.1 4.3-1.3 6.2-.3 3.2.1 6.6.6 9.8.3 1.8 1.4 6.1-.3 7.5 2-1.8 2.4-4.8 2.7-7.3.3-3.4.3-6.7 1.3-10 1.7-5.6 5.9-11 11.1-14 2.3-1.4 4.8-2.1 6.9-2.8 3.3-1 8.2.6 9.6 2.2.1-8.6-14.2-8.2-20-6.1z" />
            <path d="M222.775 27.88c-.9-3.8-5.1-5.6-8.1-7-2.2-1-6-2.4-11.1-2.5-2.4-2-6.3-4.6-11.6-6.3-1.8-.6-7.3-2.2-16.9-1.4-17.7 1.5-30.6 10-30.4 10.3.1.3 8.9-5.4 22.9-6.7 11.2-1 18.8 1.4 21.1 2.2 4.8 1.6 8.4 3.8 10.9 5.5 5 .5 8.9 1.5 11.7 2.3 4.8 1.4 6 2.4 6.8 3.3 1.9 2.5 1.5 4.2 1.5 7.1-.1 2.9-1 5.1-2.4 9.7 3.7-3.7 5.1-6.4 5.7-9.7.4-3.1.3-5.5-.1-6.8zm-90-22.3c-.1-3.1 3.8 1.5 3.8 6.8 0 2.3-2 7-5.4 10.4-1.2 1.2-4.1 2-3.1.4 5.1-7.9 4.8-13.7 4.7-17.6zm22.2 30.5c-4.9 1.6-9.4 3.6-13.4 5.5-3.8-1.7-8.3-2.6-8.3-4.4 0-3.7 9.4-7.4 13.5-6.7.4.1.9 0 1.2-.5.5-1.2 1.8-4.1-2-4.1-5.5 0-16 5.4-16 11.2 0 1.3.3 2.4.9 3.3l-.3.6c-2.8 4-8.9 11.2-15 11.2-5.6 0-6.1-5.3-5.5-9.1.2-1.2.4-2.6.9-3.9.9.5 2.1.9 3.3.9 4.4 0 9.8-5.4 9.8-9.6 0-3.8-3.3-5.4-5.7-5.3-4.1.1-12.3 10.8-12.8 20.3-.3 7.9 4.8 10.7 9 10.7 7.9 0 15.1-9.6 17.1-14.6 1.2 1.3 2.9 2.2 4.5 2.9-6.3 3.9-10.2 7.7-10.2 10.2 0 3.1 2.5 4.4 5.1 4.4 6.3 0 15.2-6.3 15.2-12.4 0-1.5-.9-2.7-2.2-3.6 3.4-1.8 7.1-3.6 10.8-5 .8-.4 1.9-2.6.1-2zm-36.5-7.6c1 0 1.4 1.1 1.1 2.4-.6 3.1-3.8 7.4-7.7 5.9 1.8-4.3 4.5-8.4 6.6-8.3zm13.2 27.2c-1.5 0-2.1-.5-2.1-1.1 0-2.3 3.9-5.5 9.5-8.9 2 .7 3.3 1.4 3.3 2.4 0 3.4-6.6 7.6-10.7 7.6zm7.7 18.2c-3.9 0-9.1 10.5-13 19.5 1.7-7.3 4.3-12.6 4.3-15.2 0-2.8-3.4-4.2-4.5-4.2 1.1 1.8-.7 7.8-2.5 13.9-.2.3-.5.7-.7 1.1-2.8 4-8.9 11.2-15 11.2-5.6 0-6.1-5.3-5.5-9.1.2-1.2.4-2.6.9-3.9.9.5 2.1.9 3.3.9 4.4 0 9.8-5.4 9.8-9.6 0-3.8-3.3-5.4-5.7-5.3-4.1.1-12.3 10.8-12.8 20.3-.1 1.5.1 2.8.3 3.9-2.7 3.8-6.1 7.9-8.4 7.9-6.3 0 4.3-23 4.3-26.1 0-3.2-2.8-4.8-5.2-4.8-4.1-.2-15 23.6-16.2 23.6s7.3-18.7 7.3-21.1c0-1.8-2.3-4.2-4.5-4.2-2.9 0-11.9 16-16.7 25.4.4-4.5 7-18.1 7-19.9 0-2.5-2.7-3.8-5.1-4.3.9 3.1-6.3 20.6-6.3 25.4 0 4.4 2.3 5 3.3 4.6 2.3-.6 14.6-27 17.4-27 1.5 0-5.7 13.1-6.3 18.6-.3 3.7 1.5 6.1 3.9 6.1 2.7 0 12.9-23.8 16.7-23.8 1.8 0-6.4 12.9-6.4 23 0 4.6 3.9 7.1 6.9 7.1 2.8 0 6.7-3.4 9-9 1.6 3.6 5.1 5 8 5 6.1 0 11.9-5.8 15.1-10.7-1.1 3.9-1.8 7.1-1.2 8.2.3.8 1.9 1.8 2.5 1.8 2.8 0 11.8-26.7 16.3-26.7 1.5 0 .3 3.4-.9 6.7-.6 1.6-.3 2.5.6 2.5 1.1 0 4.5-1.7 4.9-5 .3-3-2.5-6.8-4.9-6.8zm-28.5 2.4c1 0 1.4 1.1 1.1 2.4-.6 3.1-3.4 7.6-7.7 5.9 1.9-4.3 4.6-8.4 6.6-8.3z" />
            <path
              fill="#c62626"
              d="m152.075 60.18 3.3 1c.2.1.3 0 .5-.1l2.7-2.2c.3-.3.9 0 .9.4l.1 3.5c0 .2.1.3.3.4l2.9 2c.3.3.3.8-.1.9l-3.3 1.1c-.2.1-.3.2-.3.3l-.9 3.4c-.1.4-.7.5-.9.2l-2.1-2.8c-.1-.2-.3-.2-.4-.2l-3.5.2c-.4 0-.7-.5-.4-.9l2.1-2.9c.1-.2.1-.3.1-.5l-1.2-3.2c-.5-.2-.2-.6.2-.6z"
            />
            <path d="M101.775 25.58c-3.9 0-9.1 10.5-13 19.5 1.7-7.3 4.3-12.6 4.3-15.3 0-2.8-3.4-4.2-4.5-4.2 1.1 1.8-.7 7.8-2.4 13.9-.2.3-.5.6-.7 1.1-2.7 4-8.9 11.2-15 11.2-5.6 0-6.1-5.3-5.5-9.2.2-1.2.4-2.6.9-3.9.9.5 2.1.9 3.3.9 4.4 0 9.8-5.4 9.8-9.7 0-3.8-3.3-5.4-5.7-5.3-4.2.2-12.4 11-12.8 20.5-.3 7.9 4.8 10.7 9 10.7 6.1 0 11.9-5.8 15.1-10.8-1.1 3.9-1.8 7.1-1.2 8.2.3.8 1.9 1.8 2.5 1.8 2.8 0 11.8-26.8 16.3-26.8 1.5 0 .3 3.4-.9 6.8-.6 1.6-.3 2.5.6 2.5 1.1 0 4.5-1.7 4.9-5 .2-3.1-2.6-6.9-5-6.9zm-28.5 2.4c1 0 1.4 1.1 1.1 2.4-.6 3.1-3.6 7.5-7.7 5.9 1.9-4.3 4.5-8.4 6.6-8.3z" />
            <path d="m71.475 1.38-1.5-.7c-2.8-1.4-6.8 2.2-9.6 7-3.4 5.7-7.7 15-11.1 24.4-5-.1-10.8.3-16.3.8 1.5-3.8 3.2-7.6 5.2-11.8 2.4-5.1 3.4-7.1.5-9-1.2-.8-2.7-.9-3.7-.8.1 1.1-.2 2.1-.8 3.9-1.5 5-4.1 11.4-6.7 18.3-2.9.3-5.6.8-7.7 1.3-3.5.9-3.9 1.5-3.9 2.1 0 1.7 2.5 3.3 3.5 3.3 1.5-.9 3.8-1.5 6.5-2.2-2.1 5.9-4 12-4.9 17.7-.9 5.1 4.4 7.5 4.7 4.3 1.3-8.9 3-15.8 5.5-22.9 5.2-.9 11.2-1.5 16.6-1.7-2.7 8.2-4.8 16.5-4.6 22 0 .5.7 1.1 1.5 1.5-6.2 6.5-15.6 17.4-20.6 23.5-6.1.4-20.7 1.6-22.1 1.7-1.2.2-1.6.8-1.6 1.5 0 1.4 1.5 4.1 3.3 4.1 1.6 0 11.7-3.2 18.1-4.5-5.2 6.6-12.6 16.3-12.6 18.4 0 1.5 5.8 2.4 6.5-.3 1-4.4 4.9-9.7 11.4-18.9 6.3-.7 12-1 17.1-1-1.9 8.6-3.4 16.3-3.4 18.8 0 4.3 3.6 5.6 4.4 5.6.8 0 .9-.6.9-.9s-.9-1.7-.4-4.7c.1-.9 1.3-9.4 3.4-18.7 2.4.1 4.5.2 6.6.3.6 0 1.2-.3 1.2-.9 0-.5-.7-2-1.7-2.1l-5.4-.3c2.3-9.9 5.7-21.5 5.7-23.1 0-3.3-3.6-4.3-4.8-4.3-.2 0-.8.4-1.5 1.1.7-6.9 2.2-13.4 4.1-19.5 3.5.1 7.2.6 8.3.7 0-2.4-1.2-2.8-4.1-3.2-.9-.2-2.1-.3-3.3-.3 3.1-9.1 7.1-16.5 10.5-21.3 5.2-7.3 8.7-8.3 6.8-9.2zm-26.8 79.5c-5.2.1-11 .4-15.6.9 6.9-9.4 15.3-19.2 21-23.7-1.3 5.5-3.5 14.4-5.4 22.8zm156.7 10.9c1.6-8.1 5.7-14.2 5.7-15.9 0-1.6-1.9-3-3.4-3-.8 0-1.1 2.4-1.6 4.4-1.3-1.4-2.1-2.7-3.8-2.7-4.2 0-10.3 5.9-13.8 12.4-.2 0-.5.2-.8.6-5.4 5.5-12 11.7-17.6 11.7-3.5 0-3.9-2.1-3.4-5.5 1-6.8 7.4-17.9 10.4-17.9.7 0 .4 2.1.3 3.4-.2 1.7.4 2.9 1.6 2.9 1.5 0 3.3-3.5 3.3-5.7 0-2.1-2.8-4.1-5.7-4.1-3.9 0-9.5 8.1-12.3 15.3-.3.4-.6.9-.8 1.3-.6 1.3-5.5 10.2-9.5 10.2-6.3 0 3-18.6 4.5-22.5.7-1.8-.9-3.8-2.5-3.8-.4 0-.8.4-1.6 2-1 1.9-12.5 27.6-2.1 27.6 4.6 0 9.3-6.8 10.9-9.3-.7 7.4 4 9.5 7.1 9.5 5.4 0 14.7-9.9 16.6-11.8-.9 2.3-1.1 3.4-1.1 5.4 0 4.5 4 5.6 5.3 5.6 4.1 0 8.3-7 11.4-13.3-.9 3.2-1.5 6-1.5 9.1 0 3.8 2.8 5.9 4 5.9.4 0 2.2 0 2.2-.9-.3-.7-3.5-1.9-1.8-10.9zm-14.5 7.2c-.7 0-1.1-.8-.9-2.6.5-6.1 8.8-18.3 12.2-18.3.6 0 1.8.4 2.7 1-3.7 6.2-12.3 19.9-14 19.9z" />
            <path
              d="M13.352 118.08h-3v-2.6h8.9v2.6h-3v15.6h-2.9v-15.6zm9.2-2.6h2.8v7.4h3.1v-7.4h2.9v18.2h-2.9v-8.2h-3.1v8.2h-2.9l.1-18.2zm12.8 0h7.8v2.6h-5v4.8h3.9v2.6h-3.9v5.6h5v2.6h-7.8v-18.2zm20.7 0h4.4c2.9 0 4.3 1.6 4.3 4.5v9.2c0 2.9-1.4 4.5-4.3 4.5h-4.4v-18.2zm4.4 15.6c.9 0 1.5-.4 1.5-1.8v-9.4c0-1.3-.5-1.8-1.5-1.8h-1.5v13h1.5zm8-15.6h4.3c3 0 4.3 1.4 4.3 4.2v1.1c0 1.9-.6 3.1-1.9 3.6v.1c1.5.4 1.9 1.8 1.9 3.8v3.2c0 .9 0 1.5.3 2.2h-2.9c-.2-.4-.3-.8-.3-2.2v-3.3c0-1.7-.5-2.2-1.8-2.2h-1v7.8h-2.9v-18.3zm4 7.8c1 0 1.7-.4 1.7-2v-1.3c0-1.3-.4-1.9-1.5-1.9h-1.3v5.2h1.1zm8.4-7.8h7.8v2.6h-5v4.8h3.9v2.6h-3.9v5.6h5v2.6h-7.8v-18.2zm13.5 0h3.9l3 18.2h-2.9l-.5-3.6v.1h-3.3l-.5 3.6h-2.7l3-18.3zm3.2 12.2-1.3-9h-.1l-1.3 9h2.7zm6.9-12.2h4.1l1.8 13.1h.1l1.8-13.1h4.1v18.2h-2.7v-13.7l-2.1 13.8h-2.4l-2.1-13.8h-.1v13.8h-2.5v-18.3zm15.9 0h7.8v2.6h-5v4.8h3.9v2.6h-3.9v5.6h5v2.6h-7.8v-18.2zm11.3 0h4.3c3 0 4.3 1.4 4.3 4.2v1.1c0 1.9-.6 3.1-1.9 3.6v.1c1.5.4 1.9 1.8 1.9 3.8v3.2c0 .9 0 1.5.3 2.2h-2.9c-.2-.4-.3-.8-.3-2.2v-3.3c0-1.7-.5-2.2-1.8-2.2h-1v7.8h-2.9v-18.3zm3.9 7.8c1 0 1.7-.4 1.7-2v-1.3c0-1.3-.4-1.9-1.5-1.9h-1.3v5.2h1.1zm8 6.1v-1h2.7v1.3c0 1.3.6 1.8 1.5 1.8s1.5-.4 1.5-1.8c0-1.5-.6-2.5-2.5-4.1-2.4-2.1-3.2-3.6-3.2-5.6 0-2.9 1.5-4.5 4.3-4.5s4.2 1.7 4.2 4.6v.8h-2.7v-.9c0-1.3-.5-1.8-1.5-1.8s-1.5.5-1.5 1.7c0 1.4.6 2.3 2.5 3.9 2.4 2.1 3.2 3.6 3.2 5.8 0 3-1.5 4.6-4.4 4.6s-4.1-1.9-4.1-4.8zm11.6-11.1h-.9v-2.7h2.7v2.5l-1.6 3.4h-1.4l1.2-3.2zm13.2-2.8h2.9v15.6h4.7v2.6h-7.6v-18.2zm13.1 0h3.9l3 18.2h-2.9l-.5-3.6v.1h-3.3l-.5 3.6h-2.7l3-18.3zm3.2 12.2-1.3-9h-.1l-1.3 9h2.7zm6.9-12.2h3.6l2.8 10.9h.1v-10.9h2.6v18.2h-2.9l-3.4-13.3h-.1v13.3h-2.6l-.1-18.2zm12.9 0h4.4c2.9 0 4.3 1.6 4.3 4.5v9.2c0 2.9-1.4 4.5-4.3 4.5h-4.4v-18.2zm4.4 15.6c.9 0 1.5-.4 1.5-1.8v-9.4c0-1.3-.5-1.8-1.5-1.8h-1.5v13h1.5z"
              strokeWidth={0.5}
              fill="#003166"
              stroke="#fff"
            />
          </svg>
        </div>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Manage Tags" {...a11yProps(0)} />
          <Tab label="Manage  series" {...a11yProps(1)} />
          {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Container
          style={{
            background: "rgb(230, 250, 235)",
            padding: "20px",
            borderRadius: "10px",
            maxWidth: "100%",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{
              textAlign: "left",
              marginBottom: "20px",
              fontWeight: "bold",
            }}
          >
            Manage Tags
          </h2>
          <TextField
            label="New Tag Name"
            value={newTagName}
            variant="standard"
            onChange={(e) => setNewTagName(e.target.value)}
            style={{
              color: "black",
              marginBottom: "20px",
              width: "30%",
              padding: "10px",
              marginRight: "10px",
            }}
          />
          <Button
            onClick={handleAddTag}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "10px 20px",
              cursor: "pointer",
              borderRadius: "5px",
              transform: "translate(0%, 25%)",
            }}
          >
            Add New Tag
          </Button>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell className={classes.actionsCell}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bookTags.map((tag) => (
                <TableRow
                  key={tag.id}
                  className={
                    tagBeingEdited === tag.id
                      ? "focusedRow"
                      : tagBeingEdited !== null
                      ? "dimmedRow"
                      : ""
                  }
                >
                  <TableCell>{tag.id}</TableCell>
                  <TableCell>
                    {tagBeingEdited === tag.id ? (
                      <TextField
                        focused
                        variant="standard"
                        value={tempTagName}
                        onChange={(e) => setTempTagName(e.target.value)}
                      />
                    ) : (
                      tag.name
                    )}
                  </TableCell>
                  <TableCell className={classes.actionsCell}>
                    {tagBeingEdited === tag.id ? (
                      <>
                        <Button onClick={() => handleEditTag(tag.id)}>
                          Save
                        </Button>
                        <Button onClick={() => setTagBeingEdited(null)}>
                          Cancel
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button onClick={() => startEditTag(tag.id, tag.name)}>
                          Edit
                        </Button>
                        <Button
                          onClick={() => handleOpenDialog(tag.id, tag.name)}
                        >
                          Delete
                        </Button>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>{" "}
          <Dialog open={open} onClose={handleCloseDialog}>
            <DialogTitle style={{ textAlign: "center" }}>
              {" "}
              🤨 {"Confirm Deletion"}🤨
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete tag: {`${tagTodelete}`}?<br />
                This will also remove it from all other Here's America Books.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog} color="primary">
                Cancel
              </Button>
              <Button onClick={confirmDeleteTag} color="primary">
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {" "}
        <Container
          style={{
            background: "rgb(230, 250, 235)",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <h2
            style={{
              textAlign: "left",
              marginBottom: "20px",
              fontWeight: "bold",
            }}
          >
            Manage Series
          </h2>

          <Button
            onClick={handleOpen}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "10px 20px",
              marginBottom: "20px",
              cursor: "pointer",
              borderRadius: "5px",
            }}
          >
            Add New Series
          </Button>
          <Table
            style={{
              width: "100%",
              textAlign: "left",
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Image URL</TableCell>
                <TableCell>Slug</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Meta Description</TableCell>
                <TableCell>Subtitle</TableCell>
                <TableCell>Active</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bookSeries.map((series) => (
                <TableRow
                  key={series.id}
                  className={
                    seriesBeingEdited === series.id
                      ? "focusedRow"
                      : seriesBeingEdited !== null
                      ? "dimmedRow" // Using the CSS class directly
                      : ""
                  }
                >
                  <TableCell>{series.id}</TableCell>
                  {seriesBeingEdited === series.id ? (
                    <>
                      <TableCell>
                        <TextField
                          value={tempSeries.title}
                          onChange={(e) =>
                            setTempSeries({
                              ...tempSeries,
                              title: e.target.value,
                            })
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={tempSeries.imageUrl}
                          onChange={(e) =>
                            setTempSeries({
                              ...tempSeries,
                              imageUrl: e.target.value,
                            })
                          }
                        />
                      </TableCell>
                      <TableCell>{tempSeries.slug}</TableCell>
                      <TableCell>
                        <div
                          className={
                            seriesBeingEdited === series.id
                              ? classes.editingRow
                              : classes.collapsed
                          }
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {seriesBeingEdited === series.id ? (
                            <TextField
                              value={tempSeries.description}
                              onChange={(e) =>
                                setTempSeries({
                                  ...tempSeries,
                                  description: e.target.value,
                                })
                              }
                              multiline
                              minRows={8}
                              rows={10}
                              fullWidth
                            />
                          ) : (
                            series.description
                          )}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div
                          className={
                            seriesBeingEdited === series.id
                              ? classes.editingRow
                              : classes.collapsed
                          }
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {seriesBeingEdited === series.id ? (
                            <TextField
                              value={tempSeries.metaDescription || ""}
                              onChange={(e) =>
                                setTempSeries({
                                  ...tempSeries,
                                  metaDescription: e.target.value,
                                })
                              }
                              multiline
                              minRows={4}
                              rows={6}
                              fullWidth
                              placeholder="Enter meta description for SEO"
                            />
                          ) : (
                            series.metaDescription || "No meta description"
                          )}
                        </div>
                      </TableCell>
                      <TableCell>
                        <TextField
                          value={tempSeries.subtitle}
                          onChange={(e) =>
                            setTempSeries({
                              ...tempSeries,
                              subtitle: e.target.value,
                            })
                          }
                        />
                      </TableCell>
                      <TableCell>
                        {seriesBeingEdited === series.id ? (
                          <Checkbox
                            checked={tempSeries.active}
                            onChange={(e) =>
                              setTempSeries({
                                ...tempSeries,
                                active: e.target.checked,
                              })
                            }
                          />
                        ) : (
                          <Checkbox
                            style={{ background: "red" }}
                            checked={series.active}
                            disabled
                          />
                        )}
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell>{series.title}</TableCell>
                      <TableCell
                        style={{ maxWidth: "15vw", overflow: "hidden" }}
                      >
                        {series.imageUrl}{" "}
                        {series.imageUrl && (
                          <div style={{ margin: "20px 0" }}>
                            <img
                              src={series.imageUrl}
                              alt="Preview"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        )}
                      </TableCell>
                      <TableCell>{series.slug}</TableCell>
                      <TableCell>{series.description}</TableCell>
                      <TableCell>
                        {series.metaDescription || "No meta description"}
                      </TableCell>
                      <TableCell>{series.subtitle || "No subtitle"}</TableCell>
                      <TableCell>{series.active ? "✅" : "❌"}</TableCell>
                    </>
                  )}
                  <TableCell>
                    {seriesBeingEdited === series.id ? (
                      <>
                        <Button onClick={() => handleEditSeries(series.id)}>
                          Save
                        </Button>
                        <Button onClick={() => setSeriesBeingEdited(null)}>
                          Cancel
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button onClick={() => startEditSeries(series)}>
                          Edit
                        </Button>
                        <Button
                          onClick={() =>
                            handleOpenSeriesDialog(
                              series.id,
                              series.title,
                              series.slug
                            )
                          }
                        >
                          Delete
                        </Button>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              gap: "10px",
            }}
          >
            <Button
              onClick={() => handlePageChange(pagination.currentPage - 1)}
              disabled={!pagination.hasPreviousPage}
              variant="contained"
            >
              Previous
            </Button>
            <Typography>
              Page {pagination.currentPage} of {pagination.totalPages}
            </Typography>
            <Button
              onClick={() => handlePageChange(pagination.currentPage + 1)}
              disabled={!pagination.hasNextPage}
              variant="contained"
            >
              Next
            </Button>
          </div>
          <Dialog open={openSeriesDialog} onClose={handleCloseSeriesDialog}>
            <DialogTitle style={{ textAlign: "center" }}>
              🤨 {"Confirm Series Deletion"} 🤨
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {" "}
                Are you sure you want to delete series:
                <span
                  style={{ fontWeight: "bold", color: "red" }}
                >{` ${seriesToDelete}`}</span>
                ?<br />
                This will also remove it from all other H.A. Books.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseSeriesDialog} color="primary">
                Cancel
              </Button>
              <Button
                onClick={confirmDeleteSeries}
                color="primary"
                disabled={isWorking}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </CustomTabPanel>{" "}
      <Modal
        open={addSeriesOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <AddSeries refreshSeries={refreshSeries} />
        </Box>
      </Modal>
    </>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
